var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99998 0C4.47628 0 0 4.47856 0 10C0 15.5237 4.47854 20 9.99998 20C15.5237 20 20 15.5215 20 10C20 4.47631 15.5214 0 9.99998 0ZM16.4943 16.4966C14.7584 18.2325 12.4537 19.1874 9.99998 19.1874C7.54626 19.1874 5.23925 18.2325 3.50562 16.4966C1.76973 14.7607 0.814895 12.456 0.814895 10.0023C0.814895 7.54853 1.76973 5.24154 3.50562 3.50791C5.24151 1.77202 7.54626 0.817154 9.99998 0.817154C12.4537 0.817154 14.7607 1.77202 16.4943 3.50791C18.2302 5.2438 19.1851 7.54853 19.1851 10.0023C19.1851 12.456 18.2302 14.763 16.4943 16.4966Z",
    fill: "#8F99AA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.61816 7.72774H12.3789L12.1238 9.50653H7.61816V7.72774ZM8.45563 7.07537C8.45563 5.2695 9.11702 4.47266 10.9364 4.47266H12.3811V6.32819H10.9884C10.8416 6.32819 10.7288 6.38462 10.6543 6.49523C10.5775 6.60584 10.5391 6.75031 10.5391 6.92864V15.5291H8.45563V7.07537Z",
    fill: "#8F99AA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.861f2cfdf4f49f92f566596a0d854d16.svg";
export { ForwardRef as ReactComponent };